import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-184636d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landing-page-container about-adjust-c" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "iframe-container" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    width: "608",
    height: "360",
    src: "https://www.youtube.com/embed/RIBigLsPdOk?si=p9KENlFw0Pxnc5uP",
    title: "YouTube video player",
    frameborder: "0",
    allowfullscreen: "",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    referrerpolicy: "strict-origin-when-cross-origin"
  }, "\n        ")
], -1))
const _hoisted_3 = { class: "what-is-gio" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "what-is-gio-text" }, "What is GameInfluencer.IO?", -1))
const _hoisted_5 = {
  key: 0,
  class: "p-text"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "GameInfluencer", -1))
const _hoisted_7 = { class: "p-d-flex p-mt-6 mobile" }
const _hoisted_8 = {
  key: 0,
  class: "material-icons arrow-circle"
}
const _hoisted_9 = {
  key: 1,
  class: "material-icons arrow-circle"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "demo-button",
  target: "_blank",
  href: "https://www.youtube.com/embed/RIBigLsPdOk?si=p9KENlFw0Pxnc5uP"
}, "Watch our trailer", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-d-flex p-jc-center", _ctx.view === 'brand' ? 'about-adjust' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.view === 'creator')
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
              _hoisted_6,
              _createTextVNode(" is a leading global influencer marketing platform for the games, web3-gaming, and creative industries. ")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          (!_ctx.isMobile)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "arrow_circle_left"))
            : (_openBlock(), _createElementBlock("span", _hoisted_9, "arrow_circle_down")),
          _hoisted_10
        ])
      ])
    ])
  ], 2))
}